import { graphql } from "~/gql";

export const MATTER_FRAGMENT = graphql(/* GraphQL */ `
  fragment ParentMatterParts on Matter {
    __typename
    id
    title
    status
    reference
    createdAt
    updatedAt
    template
    parentMatterId
    parent {
      id
      title
      matters {
        id
        title
      }
    }
    externalMatterId
    externalMatter {
      id
      title
      status
      leadFeeEarner {
        id
        name
      }
      client {
        id
        name
        externalReference
        type
      }
      externalReference
      organisationalUnit {
        __typename
        id
        name
        parent {
          id
          name
        }
      }
    }
    externalReference
    createdBy {
      id
      userName
      displayName
    }
    client {
      id
      name
      externalReference
      type
    }
    priceOptions {
      id
      estimatedGpm
      estimatedSuggested
      estimatedChosen
      estimatedRangeGpm
      estimatedRangeSuggestedLower
      estimatedRangeSuggestedUpper
      estimatedRangeChosenLower
      estimatedRangeChosenUpper
      fixedGpm
      fixedSuggested
      fixedChosen
      cappedChosen
      cappedGpm
      cappedSuggested
      topDownFeeTarget
      topDownHoursTarget
      topDownRateDiscount
    }
    disbursements {
      __typename
      autoFocus @client
      id
      name
      amount
      vatStatus
      order
      updatedAt
    }
    uplifts {
      __typename
      autoFocus @client
      id
      amount
      type
      order
      baseUplift {
        id
        reason
      }
    }
    discounts {
      __typename
      autoFocus @client
      id
      reason
      amount
      type
      order
    }
    technologyCharges {
      autoFocus @client
      ...TechnologyChargeParts
    }
    phases {
      __typename
      autoFocus @client
      id
      title
      html
      description
      order
      tasks {
        ...TaskParts
      }
      priceOptions {
        id
        estimatedGpm
        estimatedSuggested
        estimatedChosen
        estimatedRangeGpm
        estimatedRangeSuggestedLower
        estimatedRangeSuggestedUpper
        estimatedRangeChosenLower
        estimatedRangeChosenUpper
        fixedGpm
        fixedSuggested
        fixedChosen
        cappedChosen
        cappedGpm
        cappedSuggested
        topDownFeeTarget
        topDownHoursTarget
        topDownRateDiscount
      }
      __typename
      id
      title
      order
      work {
        __typename
        id
        phaseId
        timeLower
        timeUpper
        timeSingle
        price {
          lower
          upper
          single
        }
        selectedRate {
          id
          description
          amount
          clientId
          feeEarnerId
          feeEarnerLevelId
          deprecated
          currency {
            id
            code
            symbol
          }
        }
        feeEarnerLevel {
          id
          description
          order
        }
        feeEarner {
          id
          name
          deprecated
          feeEarnerLevel {
            id
            description
            order
          }
          rates {
            id
            description
            amount
            clientId
            feeEarnerId
            feeEarnerLevelId
            deprecated
            currency {
              id
              code
              symbol
            }
          }
          practiceArea {
            id
            name
          }
        }
        cost {
          lower
          upper
          single
        }
        costRate
        price {
          lower
          upper
          single
        }
      }
    }
    work {
      __typename
      id
      phaseId
      timeLower
      timeUpper
      timeSingle
      price {
        lower
        upper
        single
      }
      selectedRate {
        id
        description
        amount
        clientId
        feeEarnerId
        feeEarnerLevelId
        deprecated
        currency {
          id
          code
          symbol
        }
      }
      feeEarnerLevel {
        id
        description
        order
      }
      feeEarner {
        id
        name
        deprecated
        feeEarnerLevel {
          id
          description
          order
        }
        rates {
          id
          description
          amount
          clientId
          feeEarnerId
          feeEarnerLevelId
          deprecated
          currency {
            id
            code
            symbol
          }
        }
        practiceArea {
          id
          name
        }
      }
      cost {
        lower
        upper
        single
      }
      costRate
      price {
        lower
        upper
        single
      }
    }
    organisationalUnit {
      __typename
      id
      name
      parent {
        id
        name
      }
    }
    leadFeeEarner {
      __typename
      id
      name
      feeEarnerLevel {
        id
      }
    }
    pricingType
    pricingLevel
    pricingTarget
    taxStatus
    includeTasksInProposalOutput
    includeRatesInProposalOutput
    order
    gpmDangerThreshold {
      gpmDangerThreshold
      source
    }
    waiveAdminCharge
  }
`);

export const PARENT_MATTER_PHASES_FRAGMENT = graphql(/* GraphQL */ `
  fragment ParentMatterPhasesParts on ParentMatterPhase {
    id
    title
    parentMatterId
    order
    includeInProposalOutput
    matters {
      ...ParentMatterParts
    }
  }
`);

export const FIND_PARENT_MATTER_QUERY = graphql(/* GraphQL */ `
  query FindParentMatter($id: Int!) {
    findParentMatter(id: $id) {
      id
      includeTasksInProposalOutput
      includeRatesInProposalOutput
      includeFeeEarnersInProposalOutput
      status
      title
      reference
      phases {
        ...ParentMatterPhasesParts
      }
      client {
        id
        name
        excludeTax
        gpmDangerThreshold
        externalReference
      }
    }
  }
`);
